import React from 'react';

// =====================
// Status Badge
// =====================

export const StatusBadge: React.FC<{ status: string; large?: boolean }> = ({ status, large }) => {
  const styles: Record<string, React.CSSProperties> = {
    completed: { backgroundColor: '#D1FAE5', color: '#065F46' },
    failed:    { backgroundColor: '#FEE2E2', color: '#991B1B' },
    running:   { backgroundColor: '#FEF3C7', color: '#92400E' },
    pending:   { backgroundColor: '#F3F4F6', color: '#374151' },
    paused:    { backgroundColor: '#DBEAFE', color: '#1E40AF' },
    cancelled: { backgroundColor: '#F3F4F6', color: '#6B7280' },
  };

  const labels: Record<string, string> = {
    completed: 'Abgeschlossen',
    failed:    'Fehlgeschlagen',
    running:   'Laufend',
    pending:   'Wartend',
    paused:    'Pausiert',
    cancelled: 'Abgebrochen',
  };

  const style = styles[status] || { backgroundColor: '#F3F4F6', color: '#374151' };
  return (
    <span style={{
      ...style,
      padding: large ? '4px 14px' : '2px 10px',
      borderRadius: '9999px',
      fontSize: large ? '0.875rem' : '0.75rem',
      fontWeight: 600,
      display: 'inline-block',
    }}>
      {labels[status] || status}
    </span>
  );
};

// =====================
// Format Helpers
// =====================

export const formatDate = (dateString?: string | null): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDuration = (ms?: number | null): string => {
  if (!ms) return '-';
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.floor(ms / 60000)}m ${Math.floor((ms % 60000) / 1000)}s`;
};
